<template>
  <main>
    <header class="flex flex-col md:flex-row justify-between gap-4 p-5">
      <IconsLogo class="w-60" />
      <ul class="flex flex-col md:items-end">
        <li>
          <a class="text-sm underline" href="mailto:joan.amat@statementvfx.com"
            >joan.amat@statementvfx.com</a
          >
        </li>
        <li>
          <a
            class="text-sm underline"
            href="mailto:burcak.boutella@statementvfx.com"
            >burcak.boutella@statementvfx.com</a
          >
        </li>
      </ul>
    </header>
    <div
      id="main"
      class="container mx-auto text-white py-32 px-7 flex flex-col gap-4"
      v-html="pageInfo.content"
    />
  </main>
</template>

<script setup>
import { getPage } from '~/assets/data/api'

const route = useRoute()
const slug = route?.params?.slug

const config = useRuntimeConfig()
const api = config?.public?.api
const headers = { 'Content-Type': 'application/json' }

const {
  data: pageInfo,
  pending,
  error,
  refresh,
} = await useFetch(api, {
  method: 'get',
  headers,
  query: {
    query: getPage(slug),
  },
  transform(data) {
    return data?.data?.page
  },
})
// console.log({ pageInfo })

if (!pageInfo.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Page Not Found',
    fatal: true,
  })
}

useHead({
  title: pageInfo?.value?.seo?.title,
  meta: [
    {
      name: 'description',
      content: pageInfo?.value?.seo?.metaDesc,
    },
  ],
})
useSeoMeta({
  ogTitle: pageInfo?.value?.seo?.opengraphTitle,
  description: pageInfo?.value?.seo?.opengraphDescription,
  ogDescription: pageInfo?.value?.seo?.opengraphDescription,
  // ogUrl: urlToProduction(pageInfo?.value?.seo?.opengraphurl),
  ogImage: pageInfo?.value?.seo?.opengraphImage
    ? pageInfo?.value?.seo?.opengraphImage[0]?.url
    : '',
  twitterCard: 'summary_large_image',
})
</script>

<style>
ul li {
  padding-left: 1rem;
}

ul li h4 {
  font-size: 2rem;
  text-transform: uppercase;
}
</style>
